import { useCallback, useEffect, useState } from "react";
import api, { getAllRecords } from "../api";
import SearchableSelect from "../components/SearchableSelect";
import TablePagination, { useTablePagination } from "../components/TablePagination";
const money = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`,
  date = (v) => (v ? new Date(v).toLocaleDateString("en-IN") : "—");
const blank = {
  paymentDate: new Date().toISOString().slice(0, 10),
  requestType: "adhoc",
  vehicleNo: "",
  replacedVehicle: "",
  driverName: "",
  vendorName: "",
  client: "",
  clientLocation: "",
  kmRun: "",
  totalAmount: "",
  remarks: "",
};
function Form({ close, saved }) {
  const [form, setForm] = useState(blank),
    [vehicles, setVehicles] = useState([]),
    [vendors, setVendors] = useState([]),
    [clients, setClients] = useState([]),
    [locations, setLocations] = useState([]),
    [error, setError] = useState(""),
    [saving, setSaving] = useState(false);
  useEffect(() => {
    getAllRecords("/vehicles")
      .then(setVehicles)
      .catch(() => {});
    api
      .get("/vehicles/vendors")
      .then((r) => setVendors(r.data.data || []))
      .catch(() => {});
    api
      .get("/clients")
      .then((r) =>
        setClients((r.data.data || []).filter((x) => x.status === "active")),
      )
      .catch(() => setError("Unable to load clients."));
  }, []);
  useEffect(() => {
    if (!form.client) {
      setLocations([]);
      return;
    }
    api
      .get(`/locations/client/${form.client}`, { params: { active: true } })
      .then((r) => setLocations(r.data.data || []))
      .catch(() => setLocations([]));
  }, [form.client]);
  const set = (k) => (e) =>
    setForm((x) => ({
      ...x,
      [k]: e.target.value,
      ...(k === "client" ? { clientLocation: "" } : {}),
    }));
  const own = /uride/i.test(form.vendorName);
  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/payments", {
        ...form,
        numberOfTrips: 1,
        gstAmount: 0,
        taxAmount: 0,
        tripDetails: form.requestType,
        dutyType: form.requestType === "adhoc" ? "Ad Hoc" : "Replacement",
        source: "pending",
        destination: "pending",
        ratePerTrip: own ? 0 : Number(form.totalAmount),
        totalAmount: own ? 0 : Number(form.totalAmount),
      });
      saved("Vehicle entry added.");
      close();
    } catch (err) {
      setError(err.response?.data?.message || "Unable to save vehicle entry.");
    } finally {
      setSaving(false);
    }
  };
  return (
    <div className="fuel-modal-backdrop">
      <form
        className="fuel-modal"
        onSubmit={submit}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <header>
          <div>
            <p>AD HOC VEHICLE</p>
            <h3>Add Vehicle</h3>
          </div>
          <button type="button" onClick={close}>
            ×
          </button>
        </header>
        <div className="fuel-form-grid">
          <label>
            Type
            <select value={form.requestType} onChange={set("requestType")}>
              <option value="adhoc">Ad Hoc</option>
              <option value="replacement">Replacement</option>
            </select>
          </label>
          <label>
            Payment Date
            <input
              type="date"
              value={form.paymentDate}
              onChange={set("paymentDate")}
              required
            />
          </label>
          {form.requestType === "replacement" && (
            <label>
              Vehicle being replaced
              <SearchableSelect
                value={form.replacedVehicle}
                onChange={(replacedVehicle) =>
                  setForm((current) => ({ ...current, replacedVehicle }))
                }
                options={vehicles.map((vehicle) => ({
                  value: vehicle._id,
                  label: vehicle.vehicleNumber,
                }))}
                placeholder="Type to search an existing vehicle"
                vehicleNumberSearch
                required
              />
            </label>
          )}
          <label>
            {form.requestType === "replacement"
              ? "Replacement vehicle number"
              : "Ad Hoc vehicle number"}
            <input
              value={form.vehicleNo}
              onChange={set("vehicleNo")}
              placeholder="Type temporary vehicle number"
              required
            />
          </label>
          <label>
            Temporary driver name
            <input
              value={form.driverName}
              onChange={set("driverName")}
              placeholder="Type driver name"
              required
            />
          </label>
          <label>
            Vendor (optional)
            <input
              list="payment-vendors"
              value={form.vendorName}
              onChange={set("vendorName")}
              placeholder="Type or select vendor"
            />
            <datalist id="payment-vendors">
              {vendors.map((x) => (
                <option key={x._id} value={x.name} />
              ))}
            </datalist>
          </label>
          <label>
            Client
            <select value={form.client} onChange={set("client")} required>
              <option value="">Select client</option>
              {clients.map((x) => (
                <option key={x._id} value={x._id}>
                  {x.name}
                </option>
              ))}
            </select>
          </label>
          <label>
            Client location
            <select
              value={form.clientLocation}
              onChange={set("clientLocation")}
              required
              disabled={!form.client}
            >
              <option value="">Select client location</option>
              {locations.map((x) => (
                <option key={x._id} value={x._id}>
                  {x.name}
                </option>
              ))}
            </select>
          </label>
          <label>
            KM Run
            <input
              type="number"
              min="0"
              value={form.kmRun}
              onChange={set("kmRun")}
            />
          </label>
          {own ? (
            <p className="wide vehicle-own-note">
              URIDE vendor: no one-day payment is required.
            </p>
          ) : (
            <label>
              One-day amount
              <input
                type="number"
                min="0.01"
                step="0.01"
                value={form.totalAmount}
                onChange={set("totalAmount")}
                required
              />
            </label>
          )}
          <label className="wide">
            Remarks
            <textarea rows="3" value={form.remarks} onChange={set("remarks")} />
          </label>
          {error && <p className="fuel-error">{error}</p>}
        </div>
        <footer>
          <button type="button" className="cancel" onClick={close}>
            Cancel
          </button>
          <button disabled={saving}>
            {saving ? "Saving…" : "Save Vehicle"}
          </button>
        </footer>
      </form>
    </div>
  );
}
export default function AdHocPaymentsPage() {
  const pageSize = 25;
  const [records, setRecords] = useState([]), [show, setShow] = useState(false), [notice, setNotice] = useState(""), [loading, setLoading] = useState(true), [page, setPage] = useState(1), [count, setCount] = useState(0);
  const load = useCallback(async () => { setLoading(true); try { const response = await api.get("/payments", { params: { page, limit: pageSize } }); setRecords(response.data.data || []); setCount(Number(response.data.count) || 0); } catch (error) { setNotice(error.response?.data?.message || "Unable to load entries."); } finally { setLoading(false); } }, [page]);
  useEffect(() => { load(); }, [load]);
  return <div className="fuel-mis"><div className="fuel-mis-heading"><div><p>PAYMENTS</p><h2>Ad Hoc Vehicle</h2><span>Record temporary adhoc vehicles and replacements.</span></div><div className="fuel-mis-actions"><button onClick={() => setShow(true)}>+ Add Ad Hoc Vehicle</button></div></div>{notice && <div className="fuel-notice">{notice}</div>}<section>{loading ? <p>Loading entries...</p> : <><div className="fuel-table"><table><thead><tr>{["Date", "Type", "Temporary Vehicle", "Replaced vehicle", "Client location", "Amount", "Payment Status"].map(column => <th key={column}>{column}</th>)}</tr></thead><tbody>{records.map(item => <tr key={item._id}><td>{date(item.paymentDate)}</td><td>{item.requestType || item.dutyType}</td><td>{item.vehicleNo}</td><td>{item.replacedVehicle?.vehicleNumber || "—"}</td><td>{item.routeLocation || "—"}</td><td>{money(item.totalAmount)}</td><td>{item.paymentStatus === "paid" ? "Payment Done" : item.paymentStatus || "Pending"}</td></tr>)}{!records.length && <tr><td colSpan="7">No ad hoc vehicle entries found.</td></tr>}</tbody></table></div><TablePagination page={page} setPage={setPage} total={count} pageSize={pageSize} label="Ad hoc payments" /></>}</section>{show && <Form close={() => setShow(false)} saved={message => { setNotice(message); load(); }} />}</div>;
}

function LegacyAdHocPaymentsPage() {
  const [records, setRecords] = useState([]),
    [show, setShow] = useState(false),
    [notice, setNotice] = useState(""),
    [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      setRecords(await getAllRecords("/payments"));
    } catch (e) {
      setNotice(e.response?.data?.message || "Unable to load entries.");
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const { page, setPage, pageRows } = useTablePagination(records);
  return (
    <div className="fuel-mis">
      <div className="fuel-mis-heading">
        <div>
          <p>PAYMENTS</p>
          <h2>Ad Hoc Vehicle</h2>
          <span>Record temporary adhoc vehicles and replacements.</span>
        </div>
        <div className="fuel-mis-actions">
          <button onClick={() => setShow(true)}>+ Add Ad Hoc Vehicle</button>
        </div>
      </div>
      {notice && <div className="fuel-notice">{notice}</div>}
      <section>
        {loading ? (
          <p>Loading entries…</p>
        ) : (
          <>
          <div className="fuel-table">
            <table>
              <thead>
                <tr>
                  {[
                    "Date",
                    "Type",
                    "Temporary Vehicle",
                    "Replaced vehicle",
                    "Client location",
                    "Amount",
                    "Payment Status",
                  ].map((x) => (
                    <th key={x}>{x}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pageRows.map((x) => (
                  <tr key={x._id}>
                    <td>{date(x.paymentDate)}</td>
                    <td>{x.requestType || x.dutyType}</td>
                    <td>{x.vehicleNo}</td>
                    <td>{x.replacedVehicle?.vehicleNumber || "—"}</td>
                    <td>{x.routeLocation || "—"}</td>
                    <td>{money(x.totalAmount)}</td>
                    <td>
                      {x.paymentStatus === "paid"
                        ? "Payment Done"
                        : x.paymentStatus || "Pending"}
                    </td>
                  </tr>
                ))}
                {!records.length && (
                  <tr>
                    <td colSpan="7">No ad hoc vehicle entries found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <TablePagination page={page} setPage={setPage} total={records.length} label="Ad hoc payments" />
          </>
        )}
      </section>
      {show && (
        <Form
          close={() => setShow(false)}
          saved={(m) => {
            setNotice(m);
            load();
          }}
        />
      )}
    </div>
  );
}
